import { ISection } from "interfaces/Templates";
import { IReturnAction } from "us.common/interfaces";
import { DEFAULT_DRAWER_STATE, DrawerType } from "constants/TemplateEditor";

export enum EditorType {
  HTML = "HTML",
  XML = "XML",
}

export type SectionEditorType = EditorType.HTML | EditorType.XML;

export enum DataTokenType {
  INT = "int",
  VARCHAR = "varchar",
  NVARCHAR = "nvarchar",
  DECIMAL = "decimal",
}

export type DataToken = {
  tokenName: string;
  tokenValue: string;
  tokenType: string;
  tokenDataValue?: string;
  tokenDescription?: string;
};

export type DrawerInfo = {
  visible: boolean;
  title: string;
  type: DrawerType;
  size?: string;
  content?: string;
};

type Adapter = {
  adapterId: number;
  adapterName: string;
  isRepeating: boolean;
  scriptName: string;
  dataTokens: DataToken[];
};

export interface ITemplateEditor {
  section: {
    name: string;
    width: number;
    height: number;
    repeatingAdapterId: number;
    rules: string[];
    reusable?: boolean;
    defaultRule?: string;
    properties: {
      width: number;
      height: number;
      top: number;
      bottom: number;
      left: number;
      right: number;
      x: number;
      y: number;
    };
    id: string;
    selectedRule: string;
    color: string;
    locked: boolean;
    repeatable: boolean;
  };
  parameters: {
    standard: Adapter;
    repeating: Array<Adapter>;
    isLoading: boolean;
  };
  sections: {
    data: Array<ISection>;
    isLoading: boolean;
  };
  adapters: {
    data: {
      standard: Array<Adapter>;
      repeating: Array<Adapter>;
    };
    isLoading: boolean;
  };
  templateRules: {
    data: TemplateRule;
    isLoading: boolean;
    isSaving: boolean;
  };
  drawerInfo: DrawerInfo;
  previewData: {
    data: Array<any>;
    isLoading: boolean;
  };
  repeatingAdapters: {
    data: Array<any>;
    isLoading: boolean;
  };
  editorSettings: {
    clipboard: any;
  };
  templatePreview: {
    data: Array<string>;
    isLoading: boolean;
  };
}

export interface ITemplateEditorAction {
  [key: string]: {
    selectSection?: <T>(data: Array<T> | object) => IReturnAction<T>;
    addNewPage?: <T>(data: Array<T> | object) => IReturnAction<T>;
    reformRules?: <T>(data: Array<T> | object) => IReturnAction<T>;
    deleteRule?: <T>(data: Array<T> | object) => IReturnAction<T>;
    deletePage?: <T>(data: Array<T> | object) => IReturnAction<T>;
    updateRule?: <T>(data: Array<T> | object) => IReturnAction<T>;
    manageDrawer?: <T>(data: Array<T> | object) => IReturnAction<T>;
    updateEditor?: <T>(data: Array<T> | object) => IReturnAction<T>;
  };
}

export interface InvoiceSearchParams {
  searchText?: string;
  startimportdate: string;
  endimportdate: string;
}

export interface InvoiceDeleteParams {
  fileId: number;
  comment: string;
}

export type TemplateRule = {
  id: string;
  templateId: number;
  ruleExpressions: Array<string>;
  rules: Array<any>;
};

type PreviewDataPayloadItem = {
  adapterId: number;
  itemId: number;
};
export type PreviewDataPayload = Array<PreviewDataPayloadItem>;

export type MessageTemplatesUpdateParams = {
  templateId: number;
  IsDelete: boolean;
};

export type TemplatePreviewAdapterDataItem = {
  adapterId: number;
  itemId: number;
};

export type TemplatePreviewPayload = {
  templateId: number;
  adapterData: TemplatePreviewAdapterDataItem[];
};
